import React, {Component} from 'react'

class SwitchWidget extends Component
{
	constructor(props) {
		super(props)
		this.state = {
			isOn: (props.isOn == null)? false: props.isOn,
			onToggle: props.onToggle,
			isDisabled: props.isDisabled
		}
		this.onToggleSwitch = this.onToggleSwitch.bind(this)
	}

	onToggleSwitch(isOn) {
		if(this.state.onToggle != null) {
			this.state.onToggle(isOn)
		}
	}

	componentDidUpdate(prevProps) {
		if(this.props.isOn != prevProps.isOn) {
			this.setState({isOn: this.props.isOn})
		}
	}

	render() {
		const cStyle = {}
		if(this.state.isOn == true && this.props.view === 'view-details') {
			cStyle['pointer-events'] = 'none'
			cStyle['justify-content'] = 'flex-end'
			cStyle['background-color'] = '#c6c6c6'
		}
		else if(this.state.isOn == false && this.props.view === 'view-details') {
			cStyle['pointer-events'] = 'none'
			cStyle['justify-content'] = 'flex-start'
			cStyle['background-color'] = '#c6c6c6'
		}
		else if (this.state.isOn == true && this.props.view != 'view-details') {
			cStyle['justify-content'] = 'flex-end'
			cStyle['background-color'] = '#556e2c'
		}
		else {
			cStyle['justify-content'] = 'flex-start'
			cStyle['background-color'] = '#c6c6c6'
		}
		let view
		if(this.props.isDisabled) {
			view = <div className="switch-widget" style={cStyle}><div></div></div>
		}
		else {
			view = <div className="switch-widget" style={cStyle} onClick={() => {
				this.onToggleSwitch(!this.state.isOn)
				this.setState({isOn: !this.state.isOn})
			}}><div></div></div>
		}
		return(view)
	}
}

export default SwitchWidget
